/**
 * Persistent Save System using browser localStorage.
 * Encapsulates serialization, deserialization, and privacy-mode safety.
 */

const SAVE_KEY = "robot_os_save_data";

export function saveGame(data) {
    try {
        localStorage.setItem(SAVE_KEY, JSON.stringify(data));
        return true;
    } catch (e) {
        console.warn("Save storage error:", e);
        return false;
    }
}

export function loadGame() {
    try {
        const raw = localStorage.getItem(SAVE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        console.warn("Load storage error:", e);
        return null;
    }
}

export function hasSave() {
    return loadGame() !== null;
}

export function clearSave() {
    try {
        localStorage.removeItem(SAVE_KEY);
    } catch (e) {
        console.warn("Clear storage error:", e);
    }
}
